<template>
    <ol class="mt-auto" v-if="size === 'full'">
        <li
            class="mb-1 flex flex-col"
            v-for="(event, eIndex) in events"
            :key="'event-' + eIndex"
            v-show="eIndex < 3"
        >
            <a href="#" class="flex gap-2 justify-between items-center">
                <span class="block w-1 h-4 bg-slate-800 rounded-sm"></span>
                <p
                    class="truncate text-left text-slate-800 text-sm font-normal flex-1"
                >
                    {{ event.name }}
                </p>
                <p class="text-orange-600 text-sm font-normal">
                    <EventMinPoints :rates="event.rates" />
                </p>
            </a>
        </li>
    </ol>

    <p
        class="flex items-center justify-center text-orange-600 leading-0 text-xs"
        v-if="size === 'mini'"
        :class="{
            'text-white': active,
            'text-orange-600': !active,
        }"
    >
        {{ minPoints }}
    </p>

    <span
        class="flex justify-start text-slate-500 text-sm"
        v-if="size === 'full' && events.length > 3"
    >
        {{ events.length - 3 }} more
    </span>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useCalendarStore } from '@/store/calendar';
import EventMinPoints from '@/components/calendar/partials/event-min-points.vue';

export default {
    name: 'DayItems',
    components: {},
    props: {
        size: {
            type: String,
            default: 'full', // full | mini
        },
        events: {
            type: Array,
            required: true,
        },
        active: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        bgColors: [
            'bg-blue-500',
            'bg-red-500',
            'bg-green-500',
            'bg-gray-500',
            'bg-amber-500',
        ],
    }),
    components: {
        EventMinPoints,
    },
    computed: {
        ...mapState(useCalendarStore, ['loading', 'view']),
        minPoints() {
            let value = 1000;
            let points = [];
            let cash = [];
            let pointsCash = [];
            this.events.forEach((event) => {
                event.rates.forEach((rate) => {
                    if (rate.rate_type === 'points') {
                        points.push(rate.points);
                    }
                    if (rate.rate_type === 'points_cash') {
                        cash.push(rate.rate);
                        pointsCash.push(rate.points);
                    }
                });
            });

            if (points.length === 0 && cash.length === 0) {
                return '';
            }

            let cashSymbol = cash.length && !points.length ? '+$' : '';
            value = points.length ? points : pointsCash;

            let minCost = (Math.min(...value) / 1000)
                .toFixed(1)
                .replace('.0', '');

            return minCost + 'k' + cashSymbol;
        },
    },
    methods: {
        ...mapActions(useCalendarStore, []),
    },
};
</script>
